export default function parseNumber(val: unknown, defVal: number = 0): number {
    switch (typeof val) {
        case 'number':
            return val;
        case 'string':
            const _val = parseInt(val, 10);
            if (isNaN(_val)) return defVal;
            else return _val;
        default:
            return defVal;
    }
}
